<template>
  <v-row>
    <v-col cols="12">
      <v-card tile flat color="transparent">
        <v-card-title class="px-0 pt-0">
          <div class="headline">Workers</div>
        </v-card-title>

        <v-card-text class="pa-0">
          <v-fade-transition mode="out-in">
            <table-skeleton-loader v-if="loading.users" />

            <v-row v-else-if="users.length">
              <v-col cols="12">
                <users-table :users="workers" />
              </v-col>
            </v-row>

            <v-row v-else>
              <v-col cols="12">
                <v-card width="100%" outlined>
                  <v-card-text>
                    <div class="title">No users found.</div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-fade-transition>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TableSkeletonLoader from '@/components/loading/TableSkeletonLoader'
import UsersTable from '@/components/users/UsersTable'

export default {
  name: 'Workers',
  components: {
    TableSkeletonLoader,
    UsersTable
  },
  computed: {
    ...mapGetters('users', ['users', 'loading']),
    workers() {
      return this.users.filter(
        user => user.roles.includes('worker') || user.roles.includes('manager')
      )
    }
  },
  methods: {
    ...mapActions('users', ['fetchUsers'])
  },
  created() {
    this.fetchUsers()
  }
}
</script>
